import TextContentTranslationResourceModel from '../../generated/types/model/resource/TextContentTranslationResourceModel';

export default class TextContentTranslationResourceViewModel extends TextContentTranslationResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
